<template>
  <div class="c-collections-container">
    <div v-if="filtered">
      <product-grid
        :products="products"
        :filtered="filtered"
        :max-products="numberOfProductsVisible"
      />
      <load-more
        :total-products="products.length"
        :visible-products.sync="numberOfProductsVisible"
        @loadMoreProducts="loadMoreProducts"
      />
    </div>
    <template v-else>
      <product-grid
        v-for="(collection, index) in visibleCollections"
        :key="`${collection.name}-${collection.products.length}-${index}`"
        :collection-handle="handle"
        :products="collection.products"
        :name="collection.name"
        :filtered="filtered"
        :truncate="group"
      />
    </template>
    <div
      v-observe-visibility="{
        callback: visibilityChanged,
      }"
      class="visibility-trigger"
    />
  </div>
</template>

<script>
import ProductGrid from '../productGrid/ProductGrid'
import { indexByLabel, sortByLabel } from '../../utils/collectionHelper'
import LoadMore from '../loadMore/LoadMore.vue';


export default {
  name: "CollectionsContainer",
  components: {
    ProductGrid,
    LoadMore
  },
  props: {
    title: {
      type: String,
      default: 'Shop All'
    },
    handle: {
      type: String,
      default: ''
    },
    products: {
      type: Array,
      default: () => []
    },
    sections: {
      type: Array,
      default: () => []
    },
    filtered: {
      type: Boolean,
      default: false,
    },
    group: {
      type: Boolean,
      default: false,
    },
    firstInstance: {
      type: Boolean,
      default: true,
    },
    collectionOrder: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      numberOfSectionsVisible: 1,
      numberOfProductsVisible: 32,
    }
  },
  computed: {
    catchAllGroupTitle() {
      const collectionOrder = this.collectionOrder
      const title = this.title
      return collectionOrder && collectionOrder.includes(title)
        ? 'Shop Enso'
        : title
    },
    productMap() {
      const products = this.products
      const collectionOrder = this.collectionOrder
      const title = this.catchAllGroupTitle
      return indexByLabel(products, collectionOrder, title)
    },
    productMapStats() {
      const productMap = this.productMap
      const visible = this.visibleCollectionLabels.length
      const input = this.products.length
      const total = Object.values(productMap).flat().length
      const labels = Object.keys(productMap).length
      return { total, input, labels, visible }
    },
    collectionLabels() {
      const productMap = this.productMap
      const collectionOrder = this.collectionOrder
      const firstInstance = this.firstInstance
      const filtered = this.filtered
      const title = this.catchAllGroupTitle
      return sortByLabel(productMap, collectionOrder, {
        firstInstance,
        filtered,
        fallback: title,
      })
    },
    visibleCollectionLabels() {
      const labels = this.collectionLabels
      const numberOfSectionsVisible = this.numberOfSectionsVisible
      let result = []
      for (let collection of labels) {
        if (result.length < numberOfSectionsVisible) {
          result.push(collection)
        } else {
          break
        }
      }
      return result
    },
    visibleCollections() {
      const visible = this.visibleCollectionLabels
      const productMap = this.productMap
      let result = []
      for (let collection of visible) {
        result.push({ products: productMap[collection], name: collection })
      }
      return result
    },
    reviewObject() {
      for (const section of this.sections) {
        if (
          section &&
          section.sys &&
          section.sys.contentType.sys &&
          section.sys.contentType.sys.id == "row" &&
          section.fields.column[0].fields.card.fields.cardType == "Review"
        ) {
          return section
        }
      }
      return null
    },
    featureBenefitObject() {
      for (const section of this.sections) {
        if (
          section &&
          section.sys &&
          section.sys.contentType.sys &&
          section.sys.contentType.sys.id == "row" &&
          section.fields.column[0].fields.card.fields.cardType == "Content Card"
        ) {
          return section
        }
      }
      return null
    },
  },
  methods: {
    visibilityChanged() {
      this.numberOfSectionsVisible += 10
      this.$emit(
        'update:pagination',
        this.numberOfSectionsVisible,
        this.productIndex
      )
    },
    loadMoreProducts(){
      this.numberOfProductsVisible += 16
    }
  }
}
</script>

<style>
.c-collections-container {
}
</style>
